
<app-cc-form-dialog #ccAllocationFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue"
                    [submitButtonLabel]="'page.'+transPartKey+'.dialog.create'|translate"
                    [dialogClass]="'allocation-dialog'"
>
</app-cc-form-dialog>

<p-toast position="bottom-right" ></p-toast>
